import {
  DriverInDeliveriesListItem,
  DriversDeliveriesTotals
} from "../financial.types";

export const getDriversDeliveriesTotals = (
  items: DriverInDeliveriesListItem[]
): DriversDeliveriesTotals =>
  items.reduce<DriversDeliveriesTotals>(
    (acc, item) => ({
      totalAmountToCollect: acc.totalAmountToCollect + item.totalAmountToCollect,
      totalAmountToPay: acc.totalAmountToPay + item.totalAmountToPay,
      totalAmountPaid: acc.totalAmountPaid + item.totalAmountPaid,
      totalAmountCollected: acc.totalAmountCollected + item.totalAmountCollected,
      deliveredOrdersCount: acc.deliveredOrdersCount + item.deliveredOrdersCount,
      failedOrdersCount: acc.failedOrdersCount + item.failedOrdersCount,
      unpackedFailedOrdersCount:
        acc.unpackedFailedOrdersCount + item.unpackedFailedOrdersCount,
      waitingToUnpackFailedOrdersCount:
        acc.waitingToUnpackFailedOrdersCount +
        item.waitingToUnpackFailedOrdersCount
    }),
    {
      totalAmountToCollect: 0,
      totalAmountToPay: 0,
      totalAmountPaid: 0,
      totalAmountCollected: 0,
      deliveredOrdersCount: 0,
      failedOrdersCount: 0,
      unpackedFailedOrdersCount: 0,
      waitingToUnpackFailedOrdersCount: 0
    }
  );
